<div class="emd-form-group">
    <label
        [for]="id"
        class="emd-label"
        [ngClass]="{
            _state_error: control.touched && control.invalid && !control.pristine,
        }"
        >{{ label }}<i *ngIf="isRequired"> *</i></label
    >
    <select-live-search
        [attributeNameOfContentObjectOnListToOutput]="fieldConfig.key"
        [list]="fieldConfig.data"
        [inputPlaceholder]="fieldConfig.placeholder"
        (getSelectedContent)="onSelectedItem($event)"
        [selectedContent]="fieldConfig.selectedOption"
        [disabledSelect]="control.disabled"
        (onBlur)="onTouched()"
        [hasError]="control.touched && control.invalid && !control.pristine"
        [controlName]="controlName"
    >
    </select-live-search>
    <app-control-error [control]="control" [label]="label"></app-control-error>
</div>
